// --- Core ---
import {ReactElement} from "react";
import {FieldRenderProps, useForm} from "react-final-form";
import {FormattedMessage} from "react-intl";
// --- Material UI ---
import {IconButton, Tooltip} from "@mui/material";
import {Autorenew} from "@mui/icons-material";
// --- SaniQ ---
import {TextField} from "helpers/Forms";
import {isEmpty} from "helpers/StringUtil";

interface ColorFieldProps extends FieldRenderProps<string> {
  label: ReactElement;
  placeholder: string;
  isResetDisplayed?: boolean;
}

const ColorField = ({input, placeholder, isResetDisplayed = true, ...rest}: ColorFieldProps) => {
  const {value, ...other} = input;
  const form = useForm();

  return (
    <TextField
      placeholder={placeholder}
      startAdornment={
        <input
          type={"color"}
          value={value || placeholder}
          {...other}
        />
      }
      endAdornment={
        isResetDisplayed ? (
          <IconButton
            size={"small"} disabled={isEmpty(value)}
            onClick={() => form.change(input.name, null)}
          >
            <Tooltip title={<FormattedMessage id="field.color.reset" defaultMessage="Reset to default"/>}>
              <Autorenew/>
            </Tooltip>
          </IconButton>
        )
          :
          null
      }
      input={input}
      {...rest}
    />
  );
};

export {
  ColorField
};
